import React from 'react';

import { GqlClient } from '@search/gql-client/src';
import { gqlBrowserClient } from '@search/gql-client/src/GqlBrowserClient';

import { useGeoRootRegion } from '../GeoRootRegionProvider';
import { GeoRootRegionRepository } from '../GeoRootRegionRepository';
import { clGeoRootRegionRepositoryLoad } from './clGeoRootRegionRepositoryLoad';

let state: undefined | Promise<GeoRootRegionRepository>;

export function useClGeoRootRegion({ apiPrefix = '/search/graphql' } = {}) {
    const context = useGeoRootRegion();
    const [ valueInt, setValueInt ] = React.useState(context);

    React.useEffect(() => {
        if (valueInt !== GeoRootRegionRepository.instance) return;

        const gql = new GqlClient({
            client: gqlBrowserClient({
                path: apiPrefix,
                headerAppName: 'search'
            }),
            cache: {}
        });

        state = state ?? clGeoRootRegionRepositoryLoad({ gql });

        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        state.then(rep => {
            setValueInt(rep);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ apiPrefix ]);

    return valueInt;
}
